import { useMediaQuery } from "./useMediaQuery";

/**
 * Mobile is everything below Tailwind's `md`, so JS and CSS change layout at the
 * same width. Expressed in `rem` because Tailwind's breakpoints are `rem`: with
 * a bumped browser font size a `px` query would switch somewhere other than the
 * `md:` utilities it is meant to mirror.
 */
const MOBILE_QUERY = "(width < 48rem)";

export const useIsMobile = () => useMediaQuery(MOBILE_QUERY);

/**
 * Derived from the same query instead of declaring its own `(width >= 48rem)`,
 * so the two can never disagree. The previous pair — `max-width: 768px` and
 * `min-width: 769px` — left a hole between them: at 768.5px, an ordinary width
 * once the browser is zoomed, both returned `false`.
 */
export const useIsDesktop = () => {
  const isMobile = useIsMobile();
  return () => !isMobile();
};
